export enum VisitLocationStatus {
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  UNAVAILABLE = 'unavailable',
}

export interface FieldAutomationConfig {
  enableGeoTagging: boolean;
  geoFencingRadius: number;
  // enableTripStockEntry: boolean;
  disableRetailingWithoutCheckIn: boolean;
}

export interface TotalWorkingHours {
  hours: number;
  minutes: number;
}

export interface TripLocation {
  lat: string;
  lng: string;
  address?: string;
  pincode?: string;
}

export interface DayActivity {
  tripId: string;
  clockIn: string;
  clockOut: string;
  clockInLocation?: TripLocation;
}

export interface ClockInRecord {
  date: string;
  totalWorkingHours: TotalWorkingHours;
  dayActivity: DayActivity[];
}

export interface ClockInInfo {
  tripId: string;
  clockIn: string;
  clockInLocation?: TripLocation;
  clockOut?: string;
}

export interface CheckInInfo {
  checkInId: string;
  customerId: string;
  checkInTime: string;
  checkInLocation: {
    lat: string;
    lng: string;
    address?: string;
  };
}

export interface Address {
  address1: string;
  address2?: string;
}

export interface CustomerInfo {
  customerAddress: Address;
  customerName: string;
  customerId?: string;
  phone?: string;
}

export interface TripCheckInLocation {
  lat: string;
  lng: string;
  address?: string;
  pincode?: string;
}

export interface TripCheckinRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    teamMemberId: string;
    customer_Id: string;
    checkInLocation: TripCheckInLocation;
    tripId: string;
    beatPlanScheduleRouteId?: string;
    beatPlanScheduleCustomerId?: string;
  };
}

export interface TripVisitResponse {
  id: string;
  tripId?: string;
  teamMemberId?: string;
  customerId: string;
  checkInTime: string;
  checkOutTime?: string;
  visitStatus: VisitLocationStatus;
  checkInLocation: {
    lat: string;
    lng: string;
    address?: string;
    pincode?: string;
  };
}

export interface TripCheckoutRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    teamMemberId: string;
    customer_Id: string;
    visitId: string;
  };
}

export interface TripClockinResponse {
  id: string;
  teamMemberId: string;
  workspaceId: string;
  clockInTime: string;
  clockInLocation: TripLocation;
}

export interface TripClockinRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    teamMemberId: string;
    clockInLocation: TripLocation;
  };
}

export interface TripClockoutResponse {
  id: string;
  teamMemberId: string;
  workspaceId: string;
  clockInTime: string;
  clockOutTime: string;
  clockInLocation: TripLocation;
  clockOutLocation: TripLocation;
  status: string;
}

export interface TripClockoutRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    clockOutLocation: TripLocation;
    tripId: string;
  };
}

export interface TripClockInHistoryResponse {
  totalRecords: number;
  records: ClockInRecord[];
}

export interface TripClockInHistoryRequest {
  sellerWorkspaceId: string;
  teamMemberId: string;
  startDate?: string; // format (YYYY-MM-DD)
  endDate?: string;
  isActive?: boolean;
  isToday?: boolean;
}

export interface TripCheckInHistoryRequest {
  startDate?: string; //2025-02-24
  endDate?: string; // 2025-02-24
  sellerWorkspaceId: string;
  isActive?: boolean;
}

export interface TripCheckInHistoryResponse {
  visits: TripVisit[];
}

export interface TripVisit {
  id: string;
  tripId: string;
  checkInLocation: TripLocation;
  checkInTime: string;
  checkOutTime: string | null;
  status: string;
  locationStatus: string | null;
  customerDetails: TripCustomerDetails;
}

export interface TripCustomerDetails {
  id: string;
  phone: string;
  name: string;
  companyName: string;
  physicalAddress: PhysicalAddress;
  cityName: string | null;
  location: number[];
}

export interface PhysicalAddress {
  apartment: string;
  neighborhood: string;
  suburb: string;
  city: string;
  state: string;
  country: string;
  postcode: string;
  formatted?: string;
  address1?: string;
  address2?: string;
  pinCode?: string;
}

export interface OfflineCheckInEvent {
  type: 'checkin';
  customer_Id: string;
  checkInLocation: TripLocation;
  timestamp: number;
}

export interface OfflineCheckOutEvent {
  type: 'checkout';
  customer_Id: string;
  timestamp: number;
  checkInId?: string;
}

export type OfflineEvent = OfflineCheckInEvent | OfflineCheckOutEvent;

export interface FormattedLocation {
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  country?: string;
  lat?: string;
  lng?: string;
  formatted_address?: string;
}
